// Menu summary metrics table, ported from menu_test/menu/items_list.coffee calcItemsListProps:
// 9 fixed title/value rows plus the conditional "Didn't buy anything" row. No sorting — the
// coffee view never wires onSort or per-column sort.
//
// D13(a): while a delivery re-fetch is in flight the coffee view keeps the previously rendered
// props on screen (early return on answer == 'loading'). That memoization is the component's
// job (step 4); this shaping stays pure and, absent a previous render, computes the same
// zero-value rows the coffee first render would.

import { formatAmounts } from '@aytm/app/stats/lib/util/helpers'

import { formatSeconds } from '@aytm/app/stats/page/question-views/mn/lib/format'

const round2 = value => Math.round(value * 100) / 100 || 0

export const calcMenuMetricsTable = ({ id, answer, format, priceTemplate, na } = {}) => {
  const priceMask = priceTemplate || '{{price}}'
  const hasPrice = null != priceTemplate

  // first-occurrence String.replace, NOT /gi — the metric tables/cards differ deliberately (D4)
  const orderSpend = hasPrice ? priceMask.replace('{{price}}', round2(answer?.averageOrderSpend)) : 'N/A'
  const productSpend = hasPrice ? priceMask.replace('{{price}}', round2(answer?.totalProductSpend)) : 'N/A'

  const hasBase =
    Object.hasOwn(answer || {}, 'base') ||
    Object.keys(answer || {}).some(key => null != answer[key] && Object.hasOwn(answer[key], 'base'))
  const hideTotal = Object.hasOwn(format || {}, 'hideTotal') && true === format.hideTotal

  const props = {
    id,
    cols: [
      { type: 'title', title: 'Description' },
      {
        type: 'value',
        width: 160,
        title: hasBase
          ? `<small>(based on ${formatAmounts(answer, ['base', 'total'])} responses)</small>`
          : hideTotal
            ? 'N'
            : `N <small>(from ${formatAmounts(answer?.total || 0)} resp.)</small>`
      }
    ],
    rows: [
      { cells: [{ title: 'Average order spend' }, { value: orderSpend }], position: 1 },
      { cells: [{ title: 'Average order size' }, { value: round2(answer?.averageOrderSize) }], position: 2 },
      {
        cells: [
          { title: 'Average number of unique menu items in the order' },
          { value: round2(answer?.averageUniqueProductsInOrder) }
        ],
        position: 3
      },
      {
        cells: [{ title: 'Total menu items purchased' }, { value: round2(answer?.totalProductsPurchased) }],
        position: 4
      },
      { cells: [{ title: 'Total menu items spend' }, { value: productSpend }], position: 5 },
      { cells: [{ title: 'Total sections clicked' }, { value: round2(answer?.totalSectionsClicked) }], position: 6 },
      {
        cells: [{ title: 'Average time at menu' }, { value: formatSeconds(round2(answer?.averageTimeAtMenu)) }],
        position: 7
      },
      {
        cells: [
          { title: 'Average time to first click' },
          { value: formatSeconds(round2(answer?.averageTimeToFirstClick)) }
        ],
        position: 8
      },
      {
        cells: [
          { title: 'Average attention span per section' },
          { value: formatSeconds(round2(answer?.averageAttentionPerSection)) }
        ],
        position: 9
      }
    ]
  }

  if (na) {
    props.rows.push({
      cells: [{ title: "Didn't buy anything" }, { value: round2(answer?.didntBuyAnything) }],
      position: 10
    })
  }

  return props
}
